import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { handleGoogleCallback } from '../services/oauth'
import { useDocumentMeta } from '../seo/useDocumentMeta';

function OAuthCallback() {
  useDocumentMeta();
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { saveUser } = useAuth()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  // Google 的 authorization code 是一次性的，换第二次会被拒。
  // 这个 effect 依赖 saveUser，而 AuthContext 每次 render 都会重建它 ——
  // AuthProvider 挂载后 setLoading(false) 触发的那次 re-render 就足以让 effect 再跑一遍，
  // 于是一次成功的登录反而显示 Authentication Error（StrictMode 下必现）。
  const exchangedRef = useRef(false)

  useEffect(() => {
    if (exchangedRef.current) return
    exchangedRef.current = true

    const processCallback = async () => {
      try {
        const code = searchParams.get('code')
        const state = searchParams.get('state')
        const error = searchParams.get('error')

        if (error) {
          throw new Error(`OAuth error: ${error}`)
        }

        if (!code) {
          throw new Error('No authorization code received')
        }

        const result = await handleGoogleCallback(code, state)
        
        if (result.success) {
          // 保存用户信息和token
          saveUser(result.user, result.token)
          
          // 获取保存的返回路径，如果没有则返回主页
          const returnPath = localStorage.getItem('oauth_return_path') || '/'
          
          
          // 重定向到指定路径
          navigate(returnPath)
          //localStorage.removeItem('oauth_return_path')
        } else {
          throw new Error(result.message || 'Authentication failed')
        }
      } catch (err) {
        console.error('OAuth callback error:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    processCallback()
  }, [searchParams, navigate, saveUser])

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Processing Google authentication...
      </div>
    )
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: 'red'
      }}>
        <h2>Authentication Error</h2>
        <p>{error}</p>
        <button 
          onClick={() => navigate('/')}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          Return to Home
        </button>
      </div>
    )
  }

  return null
}

export default OAuthCallback
